import styles from "../../../assets/css/popups/addinvoicepopup.module.css";
import BackBtn from "../../backbtn";
import { JSFunctions } from "../../../App";
import { useDispatch } from "react-redux";
import Toasts from "../../../assets/toasts/toasts";
import { useState } from "react";
import { Toaster } from "react-hot-toast";
import Overlay from "../../overlay";

function DelEmployeeWidgetState(props) {
  const [data, setData] = useState({
    name: "",
  });
  const [overlay, setOverlayState] = useState(false);
  const dispatch = useDispatch();
  const Toast = new Toasts();

  function cancle() {
    dispatch({ type: "", payload: { delEmployeeWidgetState: false } });
  }
  async function del(){
      if (data.name.length === 0 ) {
        Toast.error("يجب إدخال البيانات أولا")
      } else {
        let functions = new JSFunctions();
        setOverlayState(true);
        console.log(data)
        let res = await functions.delEmployee(JSON.stringify(data));
        setOverlayState(false);
        if (!res) {
            Toast.error("حدث خطأ.");
        } else {
            Toast.success("تم حذف الموظف بنجاح")
        }
      }
  }

  return (
    <>
      <div className={styles["popup"]}>
        <div className={styles.header}>
          <h2 className={styles["title"]}>حذف موظف</h2>
          <div onClick={() => cancle("addEmployeeWidgetState")}>
            <BackBtn />
          </div>
        </div>
        <div className={styles["gp"]}>
          <input
            className={styles["pop-up-input"]}
            value={data.name}
            onChange={(ele) => {
              setData({ ...data, name: ele.target.value });
            }}
            placeholder="الإسم"
          ></input>
        </div>
      <button onClick={del}>حفظ</button>

      </div>
      <Toaster position="top-left" reverseOrder={false} />
      {overlay ? <Overlay></Overlay> : null}
    </>
  );
}

export default DelEmployeeWidgetState;
